import * as ActionTypes from './../constants';
import axios from 'axios';
import { baseUrl } from './../constants/apiConstants';
import { getUserToken} from './getUserToken'


const dispatchRequestOtpVerify = (mobile, otp) => ({
    type: ActionTypes.REQUEST_OTP_VERIFY,
    otp,
    mobile
})

const dispatchReceivedOtpVerify = res => ({
    type: ActionTypes.RECEIVED_OTP_VERIFY,
    res
})

const dispatchErrorOtp = err => ({
    type: ActionTypes.ERROR_OTP,
    err
})

export const dispatchClearOtp = () => ({
    type: ActionTypes.CLEAR_OTP_INFO
})

 



export function verifyOtp(mobile, otp) {
    // console.log(otp, 'actions otp', mobile);

    return dispatch => {
        dispatch(dispatchRequestOtpVerify(mobile, otp));
        const data = {
            phone: mobile,
            user_otp: otp
        }
        // console.log(mobile)

        axios.post(`${baseUrl}/api/verifyotp`, data)
            .then(res => {
                // console.log(res, 'action verify otp res');              
                dispatch(dispatchReceivedOtpVerify(res));  
                // getUserToken(res);             
            })
            .catch(e => {
                // console.log(e, 'actions verify otp err');
                dispatch(dispatchErrorOtp(e.response));
                
            })
    }
}